import {
    SET_LOCATION
} from "../actions/types";
  
  const initialState = {
    location:null
};
  
  export default function(state = initialState, action) {
    switch (action.type) {
      case SET_LOCATION:
        return {
            location:action.payload
        };
  
      default:
        return state;
    }
  }
  